import { get, INTERNAL_ONLY, post } from ".";

export const internalUsernames = ["gft", "csadmin", "reset-password-test", "project", "geo", "csgft", "csdriller", "csgeol"];

export const signIn = async (username, password, callback, errorCallback) => {
  if (INTERNAL_ONLY && !internalUsernames.includes(username.toLowerCase())) {
    return errorCallback({
      internal: "The web app is under active development and temporarily unavailable for users."
    });
  }

  post(
    `user/login?username=${username}`,
    {
      password
    },
    async (data) => {
      data.user.username = data.user.username.toLowerCase();
      callback(data.user);
    },
    (error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    }
  );
};

export const logout = () => {
  return new Promise((resolve, reject) => {
    post(
      `user/logout`,
      "",
      (data) => {
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const searchUser = async (userName, callback, errorCallback) => {
  get(
    `user/searchUser?search=${userName}`,
    (data) => {
      callback(data);
    },
    (error) => {
      if (errorCallback) {
        errorCallback(error);
      }
    }
  );
};

export const resetPasswordRequest = async (email, username) => {
  return new Promise((resolve, reject) => {
    post(
      `user/resetPasswordRequest?email=${email}&username=${username}`,
      "",
      (data) => {
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const resetPassword = async (email, password, token, dev_id) => {
  const url = `user/resetPassword?token=${token}`;
  const body = {
    email,
    password
  };
  if (dev_id != null) {
    body["dev_id"] = dev_id;
  }
  return new Promise((resolve, reject) => {
    post(
      url,
      body,
      (data) => {
        resolve(data);
      },
      (error) => {
        reject(error);
      }
    );
  });
};

export const verifyEmail = async (token) => {
  const url = `user/verifyEmail?token=${token}`;
  return new Promise((resolve, reject) => {
    post(
      url,
      {},
      (data) => {
        resolve(data);
      },
      (error) => {
        resolve(error);
      }
    );
  });
};
